export const HCP_COOKIE_NAME = "hcp_accepted";

// Create hcp cookie and set to false by default
export const setCookie = (name, value, domain = null, path = "/") => {
  const date = new Date();
  date.setTime(date.getTime() + 100 * 365 * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;

  let cookieString = `${name}=${value};${expires};path=${path};secure;samesite=strict`;

  // Add domain if provided
  if (domain) {
    cookieString += `;domain=${domain}`;
  }

  document.cookie = cookieString;
};

// Function to get cookie value
export const getCookie = (name) => {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=").map((c) => c.trim());
    if (cookieName === name) {
      return cookieValue;
    }
  }

  return null;
};
